export default defineNuxtPlugin({
  name: "session",
  enforce: "pre",
  async setup(_nuxtApp) {
    const { ready, fetch } = useAppSession();
    // we don't use pre-rendering for this application, so the logic here is simple.
    // if we used pre-rendering a vue app:mounted hook. (see nuxt-auth-utils for inspiration)
    if (!ready.value) {
      await fetch();
    }
  },
});
